export default "__VITE_ASSET__6d4a97f6__"